var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box m-6"},[_c('p',[_vm._v("You are being logged out.")])])
}]

export { render, staticRenderFns }